import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api, apiErr } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { EmployeeAuthShell, Field, inputCls } from "./EmployeeLogin";
import { PasswordField, passwordValid, PASSWORD_RULE_TEXT } from "../../components/PasswordField";

export default function EmployeeRegister() {
  const [f, setF] = useState({ email: "", sin_last3: "", date_of_birth: "", password: "", password2: "" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault(); setErr("");
    if (!passwordValid(f.password)) return setErr(PASSWORD_RULE_TEXT);
    if (f.password !== f.password2) return setErr("Passwords do not match.");
    setBusy(true);
    try {
      const { data } = await api.post("/employee-auth/register", { email: f.email, sin_last3: f.sin_last3, date_of_birth: f.date_of_birth, password: f.password });
      setUser(data); navigate("/me", { replace: true });
    } catch (e2) { setErr(apiErr(e2)); } finally { setBusy(false); }
  };

  return (
    <EmployeeAuthShell title="Create your login" subtitle="We'll match these details to your employee record. Your employer may also have emailed you an invitation link."
      footer={<>Already registered? <Link to="/employee/login" className="emp-link">Sign in</Link></>}>
      <form onSubmit={submit} data-testid="employee-register-form">
        <Field label="Work email on file"><input data-testid="employee-register-email" type="email" required value={f.email} onChange={set("email")} className={inputCls} /></Field>
        <div className="grid grid-cols-2 gap-4">
          <Field label="Last 3 digits of SIN"><input data-testid="employee-register-sin" inputMode="numeric" pattern="\d{3}" maxLength={3} required value={f.sin_last3} onChange={set("sin_last3")} className={inputCls} /></Field>
          <Field label="Date of birth"><input data-testid="employee-register-dob" type="date" required value={f.date_of_birth} onChange={set("date_of_birth")} className={inputCls} /></Field>
        </div>
        <Field label="Choose a password"><PasswordField testId="employee-register-password" meter variant="employee" required value={f.password} onChange={set("password")} /></Field>
        <Field label="Repeat password"><PasswordField testId="employee-register-password2" variant="employee" required autoComplete="new-password" value={f.password2} onChange={set("password2")} /></Field>
        {err && <p data-testid="employee-register-error" className="text-sm font-medium text-rose-600 bg-rose-50 rounded-2xl px-4 py-3 mb-4">{err}</p>}
        <button data-testid="employee-register-submit" disabled={busy} className="emp-btn w-full">{busy ? "Checking…" : "Create login"}</button>
        <p className="text-xs text-slate-400 mt-5 text-center leading-relaxed">We only use these details to confirm it's you. Your full SIN is never shown in the portal.</p>
      </form>
    </EmployeeAuthShell>
  );
}
